const styles = () => ({
  question: {
    marginLeft: 9,
  },

  errorText: {
    margin: '0 0 0 9px',
  },

  contentBox: {
    background: '#fff',
    border: '1px solid rgba(89, 97, 104, 0.15)',
    borderRadius: 6,
    margin: '24px 0 24px',
    padding: '20px 30px 20px',
  },
});

export default styles;
